module.exports = __webpack_public_path__ + "media/images/athletes/2504-02bd06c2f08eeb19b4bf38aac3685f07.png";